import './Header.css';


function Header() {
  
  return (
    <div className="header">
      <h1>K. C. Chandler</h1>
    </div>
  )
}

export default Header;